export default "__VITE_ASSET__ZzwVbFT___"